import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { Model, ModelId } from '@core/shared/model';
import { AppRequestMethod } from '@core/shared/request';
import { Expose } from 'class-transformer-global-storage';
let DocumentationGetTreeResponse = /*#__PURE__*/(() => {
  let DocumentationGetTreeResponse = class DocumentationGetTreeResponse extends Model {};
  __decorate([Expose(), __metadata("design:type", Array)], DocumentationGetTreeResponse.prototype, "tree", void 0);
  DocumentationGetTreeResponse = __decorate([ModelId("DocumentationGetTreeResponse") // auto-generated by generate-model-ids
  ], DocumentationGetTreeResponse);
  return DocumentationGetTreeResponse;
})();
export { DocumentationGetTreeResponse };
;
let DocumentationGetTreeRequest = /*#__PURE__*/(() => {
  let DocumentationGetTreeRequest = class DocumentationGetTreeRequest extends Model {
    static {
      this.Response = DocumentationGetTreeResponse;
    }
  };
  DocumentationGetTreeRequest = __decorate([AppRequest('admin/documentation', 'tree', {
    httpMethod: AppRequestMethod.POST
  }), ModelId("DocumentationGetTreeRequest") // auto-generated by generate-model-ids
  ], DocumentationGetTreeRequest);
  return DocumentationGetTreeRequest;
})();
export { DocumentationGetTreeRequest };